import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import * as accountTypes from '@account/store/types'
import * as types from '@reserve/store/types'
import { mapGetters, mapMutations } from 'vuex';
import hrapi from '@orgmap/api/hr'

@Component({
    computed: mapGetters({
        user: accountTypes.USER,
        current: accountTypes.CURRENT,
        curCompany: types.CALENDAR_COMPANY
    }),

    methods: mapMutations({
        setCurCompany: types.CALENDAR_COMPANY
    })
})
export default class CompanySelectionPane  extends Vue { 
    setCurCompany!: (comCode: string | null) => void;

    user!: account.User;
    current!: account.TCurrent;
    curCompany!: string | null;
    
    selectedCode: string | null = null;
    companies: orgmap.Company[] = [];    
    
    get lang() {
        return this.current.userConfig.language;
    }

    created() {    
        this.selectedCode = this.curCompany;
        hrapi.getCompanies().then(res => {
            this.companies = res;                  
        });
    }

    onSelectionChanged() {
        this.setCurCompany(this.selectedCode);
        var found = this.companies.find(c => c.comCode === this.selectedCode) || null;         
        this.$emit('change', found);
    }
}